/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectCostChangeCommand } from '../../models/delete-project-cost-change-command';
import { DeleteProjectCostChangeCommandResult } from '../../models/delete-project-cost-change-command-result';

export interface ApiProjectCostChangeDeleteProjectCostChangeDelete$Params {
      body?: DeleteProjectCostChangeCommand
}

export function apiProjectCostChangeDeleteProjectCostChangeDelete(http: HttpClient, rootUrl: string, params?: ApiProjectCostChangeDeleteProjectCostChangeDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCostChangeCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCostChangeDeleteProjectCostChangeDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectCostChangeCommandResult>;
    })
  );
}

apiProjectCostChangeDeleteProjectCostChangeDelete.PATH = '/api/ProjectCostChange/DeleteProjectCostChange';
